import React from "react";

import { OnboardingHubUser } from "../../models/user";
import { CrmEntity, EntityName } from "../../server/crm/dataService";
import { TestAaaActions } from "./TestAaaActions";
import { TestAMSActions } from "./TestAMSActions";
import { TestCrmDataList } from "./TestCrmDataList";
import { TestCRMParameterSetter } from "./TestCRMParameterSetter";
import { TestDataDisplay } from "./TestDataDisplay";
import { TestGeneralActions } from "./TestGeneralActions";
import { TestIDAzureActions } from "./TestIDAzureActions";
import { TestIDXboxActions } from "./TestIDXboxActions";
import { TestLogsDisplay } from "./TestLogsDisplay";
import { TestPCEnrollmentActions } from "./TestPCEnrollmentActions";
import * as styles from "./TestStyle.module.css";

type TestBaseProps = Readonly<{
  userInfo?: OnboardingHubUser;
  gameConcepts?: CrmEntity<EntityName.gaming_gameconcept>[];
  pitchConcepts?: CrmEntity<EntityName.ggp_strike>[];
  contact?: CrmEntity<EntityName.contact>;
  account?: CrmEntity<EntityName.account>;
  onboardingHubProfile?: CrmEntity<EntityName.gaming_onboardinghubprofile>;
  onboarding?: CrmEntity<EntityName.gaming_onboarding>;
  idAzure?: CrmEntity<EntityName.gaming_idazure>;
  pitch?: CrmEntity<EntityName.gaming_pitchprogram>;
  ogcEnvURL?: string;
  testLogs?: string[];
}>;

export const TestBase = ({
  userInfo,
  gameConcepts,
  pitchConcepts,
  contact,
  account,
  onboardingHubProfile,
  onboarding,
  idAzure,
  pitch,
  ogcEnvURL,
  testLogs,
}: TestBaseProps) => (
  <div className={styles.base}>
    <h1 className={styles.title}>Onboarding Hub Test Console</h1>
    <div className={styles.container}>
      <div className={styles.generalActionsWrapper}>
        <TestGeneralActions />
        <TestDataDisplay
          userInfo={userInfo}
          gameConcepts={gameConcepts}
          pitchConcepts={pitchConcepts}
          contact={contact}
          account={account}
          onboardingHubProfile={onboardingHubProfile}
          onboarding={onboarding}
          idAzure={idAzure}
          pitch={pitch}
          ogcEnvURL={ogcEnvURL}
        />
        <TestCRMParameterSetter
          contact={contact}
          account={account}
          onboardingHubProfile={onboardingHubProfile}
          onboarding={onboarding}
          idAzure={idAzure}
          pitch={pitch}
        />
      </div>
      <TestIDXboxActions email={userInfo?.emailAddress ?? ""} />
      <TestIDAzureActions email={userInfo?.emailAddress ?? ""} />
      <TestAaaActions />
      <TestAMSActions />
      <TestPCEnrollmentActions />
    </div>
    <TestCrmDataList
      dataList={[
        { title: "Contact", object: contact },
        { title: "Account", object: account },
        { title: "Onboarding Hub Profile", object: onboardingHubProfile },
        { title: "Onboarding", object: onboarding },
        { title: "IdAzure", object: idAzure },
        { title: "Pitch", object: pitch },
        { title: "Game concepts", object: gameConcepts },
        { title: "Pitch concepts", object: pitchConcepts },
      ]}
    />
    <TestLogsDisplay testLogs={testLogs} />
  </div>
);
